// Hooks de Administración · Resumen (T-cdqn). Claves propias bajo
// ["administracion", "resumen", …], al estilo de las demás secciones.
//
// staleTime 0 (y no los 60 s del QueryClient de main.tsx): el Resumen es
// la portada del módulo y se vuelve a ella justo después de cambiar algo
// en Empresa, Equipo, Activos o Checklists, y ninguna de esas mutaciones
// invalida estas claves. Cada entrada a la pantalla pide al servidor;
// mientras llega, la caché pinta lo último sin esqueleto (cache-first).
//
// Eso cubre lo que se pide desde aquí. El roster de la fila «Equipo
// invitado» viene de useRoster (lib/api/queries.ts) con 5 min de caché, y
// sólo lo invalida crear una invitación: cualquier mutación de membresía
// que se agregue a Equipo (desactivar, reactivar, cambiar rol) tiene que
// invalidar queryKeys.roster, o el conteo de esta pantalla queda viejo.

import { useQuery } from "@tanstack/react-query";
import { resumenApi } from "./api";

export const resumenQueryKeys = {
  setupStatus: ["administracion", "resumen", "setup-status"] as const,
  ultimosCambios: ["administracion", "resumen", "ultimos-cambios"] as const,
  invitaciones: ["administracion", "resumen", "invitaciones"] as const,
} as const;

export function useSetupStatus() {
  return useQuery({
    queryKey: resumenQueryKeys.setupStatus,
    queryFn: () => resumenApi.setupStatus(),
    staleTime: 0,
  });
}

export function useUltimosCambios() {
  return useQuery({
    queryKey: resumenQueryKeys.ultimosCambios,
    queryFn: () => resumenApi.ultimosCambios(),
    staleTime: 0,
  });
}

export function useInvitacionesPendientes() {
  return useQuery({
    queryKey: resumenQueryKeys.invitaciones,
    queryFn: () => resumenApi.invitacionesPendientes(),
    staleTime: 0,
  });
}
